import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function authReducer(state = initialState.auth, action) {
  switch (action.type) {
    case types.SET_AUTH_TOKEN: {
      return Object.assign({}, state, {
        accessToken: action.accessToken,
      });
    }
    case types.LOGOUT_USER:
      return Object.assign(
        {},
        {
          isFetching: false,
          accessToken: null,
          otherTabLogout: false,
        },
      );

    case types.AUTH_LOGIN_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        user: action.user,
        error: null,
      });

    case types.UPDATE_TOKEN_EXPIRY_TIME:
      return Object.assign({}, state, {
        tokenExpiry: action.tokenExpiry,
        otherTabActive: false,
      });
    default:
      return state;
  }
}
